import { render, staticRenderFns } from "./OrganLicense.vue?vue&type=template&id=dcbed26a"
import script from "./OrganLicense.vue?vue&type=script&lang=js"
export * from "./OrganLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports